var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCelebration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "celebration 1",
    clipPath: "url(#clip0_4232_53581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 11.5547C2.55431 11.5547 4.625 13.6254 4.625 16.1797C4.625 13.6254 6.69569 11.5547 9.25 11.5547C6.69569 11.5547 4.625 9.484 4.625 6.92969C4.625 9.48406 2.55431 11.5547 0 11.5547Z",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.75 11.5547C25.3043 11.5547 27.375 13.6254 27.375 16.1797C27.375 13.6254 29.4457 11.5547 32 11.5547C29.4457 11.5547 27.375 9.484 27.375 6.92969C27.375 9.48406 25.3043 11.5547 22.75 11.5547Z",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 12.9766V25.3516",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.25 15.7268C10.8148 19.4616 12.2586 24.5576 12.2586 29.8754V31.9768",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.7508 15.7266C21.186 19.4614 19.7422 24.5574 19.7422 29.8752V31.9766",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.8125 31.0393C3.84803 31.0393 4.6875 30.1998 4.6875 29.1643C4.6875 28.1287 3.84803 27.2893 2.8125 27.2893C1.77697 27.2893 0.9375 28.1287 0.9375 29.1643C0.9375 30.1998 1.77697 31.0393 2.8125 31.0393Z",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.1875 31.0393C30.223 31.0393 31.0625 30.1998 31.0625 29.1643C31.0625 28.1287 30.223 27.2893 29.1875 27.2893C28.152 27.2893 27.3125 28.1287 27.3125 29.1643C27.3125 30.1998 28.152 31.0393 29.1875 31.0393Z",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.14844 22.7891C7.24406 24.7767 8.49825 27.5734 8.49825 30.5816V31.9766",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.8498 22.7893C24.7542 24.7769 23.5 27.5736 23.5 30.5818V31.9768",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M0 20.6797H1.875",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M30.125 20.6797H32",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M3.6875 2.39062H5.5625",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M26.4375 2.39062H28.3125",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M15.9998 1.60176L17.5806 3.75476L20.1168 4.59295L18.5577 6.7617L18.5442 9.43276L15.9998 8.62014L13.4554 9.43276L13.4419 6.7617L11.8828 4.59295L14.419 3.75476L15.9998 1.60176Z",
    stroke: "black",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4232_53581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.a27b41b2de8add426cd678feb51bb947.svg";
export { ForwardRef as ReactComponent };